import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import { MarginTopWrapper, Wrapper } from './wrappers';
import { FlexCenterBetweenWrapper, GenericWrapper } from 'wrappers';
import { TechType, TechName, TechImage, TechInitials } from './atoms';
import { getInitials } from 'utils/getInitials';
import { Achievement } from './molecules';
import { Rating } from 'molecules';
import { Label } from 'molecules';
import internalState from './internalState';
import { format } from 'date-fns';

export const definition = {
  name: "MobileTechRow",
  controller: Controller,
  initialProps: ({ tech }) => ({ tech }),
  props: internalState,
  elements: [
    {
      wrapper: Wrapper,
      isButton: true,
      bindings: ({ tech }) => ({ tech }),
      name: 'TechRow',
      elements: [
        {
          wrapper: FlexCenterBetweenWrapper,
          name: 'PersonalInfo',
          elements: [
            {
              wrapper: GenericWrapper,
              name: 'Name',
              elements: [
                {
                  component: TechType,
                  name: 'TechType',
                  renderIf: ({ tech }) => !!tech.type,
                  displayValue: ({ tech }) => tech?.type
                },
                {
                  component: TechName,
                  name: 'TechName',
                  renderIf: ({ tech }) => !!tech.name,
                  displayValue: ({ tech }) => tech.name
                }
              ]
            },
            {
              component: TechImage,
              name: 'TechImage',
              renderIf: ({ tech }) => !!tech.image,
              displayValue: ({ tech }) => tech.image,
            },
            {
              component: TechInitials,
              name: 'TechInitials',
              renderIf: ({ tech }) => !tech.image,
              displayValue: ({ tech }) => getInitials(tech.name),
            }
          ]
        },
        {
          wrapper: wrap(FlexCenterBetweenWrapper, MarginTopWrapper),
          name: 'Achievements',
          elements: [
            {
              component: Achievement,
              name: 'CompletedAchievement',
              bindings: ({ tech }) => ({ color: window?.settings?.primary_color ?? '#1DBD6B', text: tech?.stats?.completed ?? 0 })
            },
            {
              component: Achievement,
              name: 'AssignedAchievement',
              bindings: ({ tech }) => ({ color: '#6457E8', text: tech?.stats?.assigned ?? 0 })
            },
            {
              component: Achievement,
              name: 'WithdrawnAchievement',
              bindings: ({ tech }) => ({ color: '#FD5E20', text: tech?.stats?.withdrawn ?? 0 })
            },
            {
              component: Achievement,
              name: 'CallbacksAchievement',
              bindings: ({ tech }) => ({ color: '#FFC700', text: tech?.stats?.callbacks ?? 0 })
            },
          ]
        },
        {
          wrapper: wrap(FlexCenterBetweenWrapper, MarginTopWrapper),
          name: 'Rating',
          elements: [
            {
              component: Label,
              name: 'Label',
              bindings: ({ tech }) => {
                const activationDeactivationDate = tech.active ? (tech.activated_at ?? tech.inserted_at) : (tech.deactivated_at ?? tech.inserted_at);
                return {
                  active: tech.active, text: `${tech.active ? 'Active' : 'Disabled'} ${activationDeactivationDate ? `since ${format(activationDeactivationDate, 'MM/dd/yyyy')}` : ''}`
                }
              },
              displayState: ({ tech }) => ({ active: tech.active })
            },
            {
              component: Rating,
              name: 'RatingStars',
              bindings: ({ tech }) => ({ rating: tech.stats?.rating })
            },
          ]
        }
      ]
    }
  ]
}

const MobileTechRow = ContainerComponent(definition)

export default MobileTechRow
